export const AD_LABEL_CLASS = 'advertisement-label';
